import loaderSvg from '@assets/logo-loader.svg';
import loaderStillSvg from '@assets/logo-loader-still.svg';
import styles from './AppLoader.module.css';

type AppLoaderProps = {
  size?: 'small' | 'default' | 'large';
  minHeight?: number | string;
  inline?: boolean;
  className?: string;
};

const buildClassName = (...names: Array<string | false | null | undefined>) =>
  names.filter(Boolean).join(' ');

export const AppLoader = ({
  size = 'default',
  minHeight,
  inline = false,
  className,
}: AppLoaderProps) => {
  const sizeClassName =
    size === 'small' ? styles.small : size === 'large' ? styles.large : styles.default;
  const loaderImage = (
    <picture className={styles.picture}>
      {/* Select a nonanimated resource; embedded SVG media queries vary across browsers. */}
      <source media="(prefers-reduced-motion: reduce)" srcSet={loaderStillSvg} />
      <img
        src={loaderSvg}
        alt=""
        className={buildClassName(styles.loaderImage, sizeClassName)}
        draggable={false}
      />
    </picture>
  );

  if (inline) {
    return (
      <span className={buildClassName(styles.inline, className)} aria-hidden="true">
        {loaderImage}
      </span>
    );
  }

  return (
    <div
      className={buildClassName(styles.block, className)}
      style={minHeight !== undefined ? { minHeight } : undefined}
      aria-hidden="true"
    >
      {loaderImage}
    </div>
  );
};
